import React, { Fragment } from 'react';
import Navbar2 from '../../components/Navbar2';
import Footer from '../../components/footer';
import Scrollbar from '../../components/scrollbar';
import WhatsAppOnboarding from '../../components/WhatsAppOnboarding';

const WhatsAppOnboardingPage = () => {
  return (
    <Fragment>
      <Navbar2 />
      <WhatsAppOnboarding />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default WhatsAppOnboardingPage;
